export const reminderEndpoints = {
  resource: "/goals",
  post: "",
  edit: "",
  delete: "",
  get: "",
};
